export default "__VITE_ASSET__5e551698__"